import consumer from "./consumer"

const trackingRoot = document.getElementById("public-tracking-realtime")

if (trackingRoot) {
  const code = trackingRoot.dataset.code
  const phone = trackingRoot.dataset.phone

  consumer.subscriptions.create(
    {
      channel: "PublicOrderTrackingChannel",
      code,
      phone
    },
    {
      received(data) {
        if (data.type !== "status_changed") return

        showTrackingToast(data)
        updateTrackingStatus(data)
        prependTimelineEntry(data)
      }
    }
  )
}

function showTrackingToast(data) {
  const toastRoot = document.getElementById("public-tracking-toast-root")
  if (!toastRoot) return

  const toast = document.createElement("div")
  toast.className = "pointer-events-auto w-full max-w-sm translate-y-3 rounded-xl border border-sky-200 bg-white p-4 opacity-0 shadow-lg transition-all duration-300"

  const title = document.createElement("p")
  title.className = "text-sm font-semibold text-sky-700"
  title.textContent = "Atualizacao de status"
  toast.appendChild(title)

  const details = document.createElement("p")
  details.className = "mt-1 text-xs text-slate-600"
  details.textContent = `${data.order_code} - ${data.transition_label}`
  toast.appendChild(details)

  toastRoot.appendChild(toast)

  window.requestAnimationFrame(() => {
    toast.classList.remove("opacity-0", "translate-y-3")
  })

  window.setTimeout(() => {
    toast.classList.add("opacity-0", "translate-y-2")
    window.setTimeout(() => toast.remove(), 300)
  }, 7000)
}

function updateTrackingStatus(data) {
  const statusNode = document.getElementById("public-tracking-current-status")
  if (!statusNode) return

  statusNode.textContent = data.status_label
}

function prependTimelineEntry(data) {
  const timelineList = document.getElementById("public-tracking-timeline-list")
  if (!timelineList) return

  const emptyState = document.getElementById("public-tracking-empty-state")
  if (emptyState) emptyState.remove()

  const item = document.createElement("li")
  item.className = "-translate-y-2 rounded-xl border border-sky-200 bg-sky-50 p-4 opacity-0 transition-all duration-500"

  const transition = document.createElement("p")
  transition.className = "text-sm font-medium text-[var(--text-strong)]"
  transition.textContent = data.transition_label

  const occurredAt = document.createElement("p")
  occurredAt.className = "mt-1 text-xs text-[var(--text-muted)]"
  occurredAt.textContent = data.occurred_at_label

  item.appendChild(transition)
  item.appendChild(occurredAt)

  timelineList.prepend(item)

  window.requestAnimationFrame(() => {
    item.classList.remove("opacity-0", "-translate-y-2")
  })

  window.setTimeout(() => {
    item.classList.remove("bg-sky-50", "border-sky-200")
    item.classList.add("border-slate-200")
  }, 3000)
}
